/**
 * /superadmin/tiers — Tier feature matrix (route shell).
 * Screen impl in `./tiers-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/tiers')({
  component: lazyRouteComponent(
    () => import('./tiers-screen'),
    'TiersScreen',
  ),
});
